import { useState } from "react";
import { Button, Tag } from "antd";

import { TEMPLATE } from "../../constants";

import { ButtonLink } from "../../components";

import {
	ModalAssign,
	ModalStandard,
} from "./modules";

const {
	MODALS_STANDARD,
	MODALS_ASSIGN,
} = TEMPLATE.MODAL;

// the commented code below are the example of how to use the modal

// dont forget to import the TEMPLATE, this TEMPLATE available inside v1

// beside being the reusable component
// the ButtonModal is a button without any styling
// so the styling itself can be customized

/* const { MODAL_ACTION } = TEMPLATE.MODAL; */

/* <ButtonModal
  setmodal={MODAL_ACTION.cancel_order}
  onClick={() => {
    console.log(MODAL_ACTION.cancel_order);
  }}
>
  test btn
</ButtonModal> */

const ButtonModal = (props) => {
	const {
		model = "",
		setmodal,
		onClick = () => {},
		extra = {},
		data = [],
		disabled,
		children,
		areatext,
	} = props;

	const [isModalOpen, setIsModalOpen] = useState(false);

	// filter the MODALS based on setmodal value
	const modals_standard = MODALS_STANDARD.filter((k) => k === setmodal)[0];
	const modals_assign = MODALS_ASSIGN.filter((k) => k === setmodal)[0];

	const handleModal = () => {
		setIsModalOpen(true);
	};

	const handleModalContext = (setmodal) => {
		switch (setmodal) {
			case modals_standard:
				return (
					<ModalStandard
						setmodal={setmodal}
						isModalOpen={isModalOpen}
						setIsModalOpen={() => setIsModalOpen(false)}
						onClick={onClick}
						extra={extra}
						data={data}
						areatext={areatext}
					/>
				);
			case modals_assign:
				return (
					<ModalAssign
						setmodal={setmodal}
						isModalOpen={isModalOpen}
						setIsModalOpen={() => setIsModalOpen(false)}
						onClick={onClick}
						data={data}
						areatext={areatext}
					/>
				);
			default:
				break;
		}
	};

	return (
		<>
			{handleModalContext(setmodal)}

			{(model === "link" && (
				<ButtonLink
					{...props}
					onClick={handleModal}
					disabled={disabled}
				>
					{children}
				</ButtonLink>
			)) ||
				(model === "tag" && <Tag color="orange">{children}</Tag>) || (
					<Button {...props} onClick={handleModal}>
						{children}
					</Button>
				)}
		</>
	);
};
export default ButtonModal;
